import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { FeatureFlags } from './utils/featureFlags';

// Always log feature flags status (even in production) for debugging
console.log('=== EnglishWritingTools App Starting ===');
console.log('Feature Flags:', {
  USE_A2A_BACKEND: FeatureFlags.USE_A2A_BACKEND,
  FALLBACK_TO_SUPABASE: FeatureFlags.FALLBACK_TO_SUPABASE,
  A2A_BACKEND_URL: FeatureFlags.A2A_BACKEND_URL,
  ENABLE_LOGGING: FeatureFlags.ENABLE_LOGGING,
  NODE_ENV: process.env.NODE_ENV
});
console.log('========================================');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);